import apiUrl from "../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import {
  Validator
} from "vee-validate";
import VueElementLoading from 'vue-element-loading';

export default {
  name: "appmodules",
  components: {
    Paginate,
    VueElementLoading
  },
  data: function() {
    return {
      modalShow: false,
      updaterolemodal: false,
      editrolemodal: false,
      addpermissionmodal: false,
      permissionaction: "",
      listPermissionsData: [],
      listPermissionData: [],
      permissionid: [],
      pageno: 0,
      pagecount: 0,
      permissionname: "",
      perm_id: [],
      roleid: [],
      projectid: 0,
      parentid:'',
      devicetype: '',
      isLoading: false,
      resultCount: '',
      model: {
        name: "",
        username: ""
      },
      addpermission: {
        permissionname: "",
        perm_name: "",
        controller_url: "",
        purl: "",
        ismenu: "",
        moduleroleoverride: "",
        is_active:"",
        isEven:false,
        backgroundColor:null,
        textColor:null
      },
      checkedPerm_Id: [],
      projectid: [],
      listProjectData: [],
      listRolesData: [],
      selected: '',
      changestatus: '',
    };
  },

  created: function() {},
  mounted() {
    this.getModuleData();
    //this.getAllProjectList();
    this.getParentRolesListData(this.$route.params.id);
  },
  methods: {
    addNewpermission() {
      this.addpermission.perm_name= "";
      this.addpermission.controller_url= "";
      this.addpermission.purl= "";
      this.addpermission.is_active=true;
      this.addpermission.sequence="";
      this.addpermission.permissionname="";
      this.addpermission.permissionid="";
      this.addpermission.ismenu=true;
      this.addpermission.moduleroleoverride="";
      this.roleid= [];
      this.projectid= 0;
      this.devicetype= "";
      this.checkedPerm_Id = [];
      this.permissionaction = "add";
      this.addpermissionmodal = true;
      this.$validator.reset();
      this.errors.clear();
      this.addpermission.isEven = false;
      this.addpermission.backgroundColor = null;
      this.addpermission.textColor = null;
    },
    closeAddPermissionModal() {
      $("#modulepageform").trigger("reset");
      this.$validator.reset();
      this.errors.clear();
      this.addpermissionmodal = false;
      this.getModuleData();
    },

    closeEditRoleModal() {
      this.addpermissionmodal = false;
      this.$validator.reset();
      this.errors.clear();
    },
    resetSearch(){
      this.permissionname = '';
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getModuleData();
    },
    resetform() {
      this.addpermission=[];
      this.projectid=[];
      this.devicetype= "";
      this.is_active= "";
      this.ismenu = "";
      this.addpermission.moduleroleoverride="";
      this.checkedPerm_Id = [];
      this.listPermissionData= [];
      this.permissionid= [];
      this.pageno = 0;
      this.addpermission.isEven = false;
      this.addpermission.backgroundColor = null;
      this.addpermission.textColor = null;
      this.getModuleData();
    },
    searchModuleData(){
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getModuleData();
    },
    redirectToSubModule(id)
    {
      //this.$router.push('#/dashboard'+id);
      if(location.href = '#/appmodules/'+id) location.reload();
    },
    closeStatusUrlModal() {
        this.modalShow = false
    },
    //to get target id in active/inactive modal
    getStatusRowData(data) {
        this.Statusaction = 'add'
        this.modalShow = true
        this.permissionid = data.permissionid
        this.is_active = data.is_active
        if (data.is_active == true)
        {
            this.changestatus = 'De-Activate'
        } else {
            this.changestatus = 'Activate'
        }
    },
    //for active/inactive modal
    changeUrlStatus() {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');

        axios({
                method: 'POST',
                'url': apiUrl.api_url + 'updateurlStatus',
                'data': {
                    'permissionid': this.permissionid,
                    'is_active': this.is_active,
                },
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then((response) => {
                if (response.data.errorCode == 0) {
                    this.$alertify.success(response.data.msg);
                    this.addusermodal = false;
                    let permissionid = this.$route.params.id;
                    this.getModuleData(permissionid);
                } else if (response.data.errorCode == -1) {
                    this.$alertify.error(response.data.msg)
                }
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
    },
    getModuleData(id) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = {
        offset: this.pageno,
        limit: 10,
        permissionname: this.permissionname,
        permissionid: this.$route.params.id
      };
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "AppmodulesMaster",
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      }).then(
        result => {
          this.listPermissionsData = result.data.rows;
          this.isLoading = false;
          let totalRows = result.data.count;
          this.resultCount = result.data.count;
          if (totalRows < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalRows / 10);
          }
        },
        error => {
          console.error(error);
        }
      );
    },

    saveAppModule(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let permission_id = parseInt(this.$route.params.id);
      axios({
          method: "POST",
          url: apiUrl.api_url + "SubmitAppModuleData",
          data: {
            permissionname: this.addpermission.permissionname,
            permissionid: permission_id,
            controller_url: this.addpermission.controller_url,
            purl: this.addpermission.purl,
            sequence: this.addpermission.sequence,
            is_active: this.addpermission.is_active,
            ismenu: this.addpermission.ismenu,
            moduleroleoverride: this.addpermission.moduleroleoverride,
            roleids: this.roleid,
            isEven: this.addpermission.isEven,
            backgroundColor: this.addpermission.backgroundColor,
            textColor: this.addpermission.textColor
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
            if (response.data.statuscode == 200) {
            this.$alertify.success("Module Created Successfully");
            this.addpermissionmodal = false;
            event.target.reset();
            this.getModuleData();
          } else if (response.data.statuscode == 209) {
            this.$alertify.error("Module Page Name Already Exist");
            //this.addpermissionmodal = false;
          } else if (response.data.statuscode == 400) {
            this.$alertify.error("Failed");
            this.addpermissionmodal = false;
          }
        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    getPermissionRowData(data) {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.$validator.reset();
      this.errors.clear();
      this.permissionaction = "edit";
      this.addpermissionmodal = true;
      this.checkedPerm_Id = [];
      this.addpermission = data;
      this.addpermission.controller_url = data.controllerurl;
      this.addpermission.sequence = data.permsequence;
      this.projectid = data.projectid;
      this.ismenu = data.ismenu;
      this.moduleroleoverride = data.moduleroleoverride;
      this.addpermission.is_active = data.is_active;
      this.roleid = data.roleids;
      this.addpermission.isEven = data.isEven;
      this.addpermission.backgroundColor = data.backgroundColor;
      this.addpermission.textColor = data.textColor;
    },

    editModule(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: "POST",
          url: apiUrl.api_url + "UpdateAppModule",
          data: {
            permissionname: this.addpermission.permissionname,
            permissionid: this.addpermission.permissionid,
            controllerurl: this.addpermission.controller_url,
            purl: this.addpermission.purl,
            permsequence: this.addpermission.sequence,
            roleids: this.roleid,
            ismenu: this.addpermission.ismenu,
            moduleroleoverride: this.addpermission.moduleroleoverride,
            is_active:this.addpermission.is_active,
            parentid:this.$route.params.id,
            isEven: this.addpermission.isEven,
            backgroundColor: this.addpermission.backgroundColor,
            textColor: this.addpermission.textColor
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
          if (response.data.statuscode == 200) {
            this.$alertify.success("Module Page updated successfully");
            this.addpermissionmodal = false;
            this.getModuleData();
          }else if (response.data.statuscode == 209) {
            this.$alertify.error("Module Page Name Already Exist");
            //this.addpermissionmodal = false;
          }else {
            this.$alertify.error("Module Page failed to update");
            this.addpermissionmodal = false;
          }
        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    //to get project list
    getAllProjectList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getallprojects',
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listProjectData = result.data.data.rows;
        }, error => {
          console.error(error)
        })
    },
    getParentRolesListData(permissionid) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getAppPermissionsRoleData',
          data: {
            permissionid: permissionid
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          let parentroleids = result.data[0].roleids;
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getRoleData',
              data: {
                roleid: parentroleids
              },
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(roleresult => {
              this.listRolesData = roleresult.data;
            }, error => {
              console.error(error)
            })
        }, error => {
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.getModuleData();
    },
    onSubmit: function(event) {
        this.$validator.validateAll().then((result) => {
        if(result){
          //console.log('form is valid', this.model);
          if(this.addpermission.permissionid!=undefined && this.addpermission.permissionid!=""){
            this.editModule(event);
          }else{
            this.saveAppModule(event);
          }
        }
      }).catch(() => {
          console.log('errors exist', this.errors)
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/appmodules/appmodules.component.js